import { effectScope, watch } from 'vue';
import { resetAssistantIdentityToken } from '../gpthelp-identity';
import { resetAssistantConfigRequests } from './assistant-config';

let hooked = false;

/**
 * Nothing of the previous identity survives a user change (plan §9.11): the
 * assistant store resets itself, and the identity token and the config
 * requests kept by these modules go with it. It watches the user on its own,
 * with the store's rule (a change away from a known user), because the
 * store's watcher calls its reset directly and action subscribers never see
 * it. Hooked once, in a detached scope: at logout the panel is unmounted
 * before the user leaves.
 */
export function hookAssistantIdentityReset(
  currentUserId: () => number | null
): void {
  if (hooked) return;
  hooked = true;
  effectScope(true).run(() => {
    watch(
      currentUserId,
      (id, previous) => {
        if (previous === null || id === previous) return;
        resetAssistantIdentityToken();
        resetAssistantConfigRequests();
      },
      // At once: no request of the next user starts with the previous state.
      { flush: 'sync' }
    );
  });
}
